import styled from "styled-components";

// Кнопки действий заказа в списке (возврат + поддержка) — столбиком
export const OrderActions = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "stretch",
  gap: 6,
}));

export const SupportButton = styled("button")(({ theme }) => ({
  ...theme.mixins.flexCenterCenter,
  gap: 6,
  height: 34,
  ...theme.paddings(0, 12),
  border: "1px solid #cbd5e1",
  borderRadius: 6,
  backgroundColor: "transparent",
  color: "#475569",
  fontSize: 13,
  fontWeight: 600,
  whiteSpace: "nowrap",
  cursor: "pointer",
  transition: "all .2s ease",

  "&:hover": {
    borderColor: theme.palette.searchButtonBg,
    color: theme.palette.searchButtonBg,
  },

  "& svg": {
    fontSize: 16,
  },
}));
